import {useApiariesStore} from "entities/apiaries";
import {useEffect} from "react";
import {Container, Text, TextContainer, Title} from "./style";
import {LogoSvg} from "shared/ui/logoSvg";
import {Button} from "@atomaro/ui-kit";
import {logout, toRem} from "shared/helpers";

export const CreateFirstApiary = () => {
  // const navigate = useNavigate();
  const apiaries = useApiariesStore(state => state.apiaries);
    const setIsCreateApiaryOpen = useApiariesStore((s) => s.setIsModalOpen);

  useEffect(() => {
    // if (apiaries.length) navigate('/');
  }, [apiaries])

  return (
    <Container>
      <LogoSvg
        width={108}
        height={108}
      />
      <TextContainer>
        <Title>Создайте свою пасеку</Title>
        <Text>Создайте свою первую пасеку, чтобы разблокировать все возможности приложения</Text>
      </TextContainer>
      <Button
        label="Создать пасеку"
        size="l"
        style={{width: '100%', maxWidth: toRem(343)}}
        onClick={() => setIsCreateApiaryOpen(true)}
      />
      <Button
        label="Выйти из аккаунта"
        size="l"
        style={{width: '100%', maxWidth: toRem(343)}}
        variant="outline"
        onClick={() => logout()}
      />
    </Container>
  )
}
